import { Logger } from '@/utils/Logger'
const isDev = import.meta.env.DEV

function getLogger() {
  const logger = new Logger(isDev)
  return logger
}

export const logger = getLogger()
